"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = require("@paprika/l10n");
var panel_1 = __importDefault(require("@paprika/panel"));
var Section_1 = __importDefault(require("../Section/Section"));
var shortcutHelpers_1 = require("../shortcutHelpers");
var sc = __importStar(require("./ShortcutPanel.styles"));
function ShortcutPanel(_a) {
    var appId = _a.appId, isOpen = _a.isOpen, handleToggleSidePanel = _a.handleToggleSidePanel, zIndex = _a.zIndex;
    var refHeading = react_1.default.useRef(null);
    var i18n = l10n_1.useI18n();
    function focusHeader() {
        if (refHeading.current)
            refHeading.current.focus();
    }
    return (react_1.default.createElement(sc.ShortcutPanel, { "data-testid": "keyboard-shortcut-panel", "data-sri-anchor": "keyboard-shortcut-panel", isCompact: true, isOpen: isOpen, onAfterOpen: focusHeader, onClose: handleToggleSidePanel, width: "450px", zIndex: zIndex },
        react_1.default.createElement(panel_1.default.Overlay, null),
        react_1.default.createElement(panel_1.default.Header, { refHeading: refHeading }, i18n.t('global_navigation.keyboard_commands.basic.header')),
        react_1.default.createElement(sc.ShortcutPanelContent, null, shortcutHelpers_1.sectionOrder[appId].map(function (section) { return (react_1.default.createElement(Section_1.default, { key: section, section: section })); }))));
}
ShortcutPanel.propTypes = {
    appId: prop_types_1.default.oneOf(prop_types_1.default.string),
    isOpen: prop_types_1.default.bool.isRequired,
    handleToggleSidePanel: prop_types_1.default.func.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
ShortcutPanel.defaultProps = {
    appId: shortcutHelpers_1.SECTIONS.DEFAULT,
    zIndex: null,
};
exports.default = ShortcutPanel;
//# sourceMappingURL=ShortcutPanel.js.map